import { knowledgeApiSlice } from "api/knowledgeApi.slice";
import { UIActionButton } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { checkArePinningTopicsPending } from "domains/pinAddReject/selectors";
import { createCanEditTopicSelector } from "entities/topics/selectors";

type KnowledgeDetailPinButtonProps = {
  topicId: string;
  knowledgeId: string;
  isPinned: boolean;
  hideButtonLabels?: boolean;
};

export const KnowledgeDetailPinButton = ({
  topicId,
  knowledgeId,
  isPinned,
  hideButtonLabels,
}: KnowledgeDetailPinButtonProps) => {
  const canEditTopic = useSelector(createCanEditTopicSelector(topicId));

  const arePinningTopicsPending = useSelector(checkArePinningTopicsPending(knowledgeId));

  const [pinKnowledge, { isLoading: isPinningKnowledge }] =
    knowledgeApiSlice.endpoints.pinKnowledgeToTopic.useMutation();
  const [unpinKnowledge, { isLoading: isUnpinningKnowledge }] =
    knowledgeApiSlice.endpoints.unpinKnowledgeFromTopic.useMutation();

  const isLoading = arePinningTopicsPending || isPinningKnowledge || isUnpinningKnowledge;

  const updatePinState = async (event: React.MouseEvent) => {
    event.stopPropagation();

    if (!isPinned) {
      await pinKnowledge({
        topicId,
        knowledgeId,
      });
    } else {
      await unpinKnowledge({
        topicId,
        knowledgeId,
      });
    }
  };

  if (!canEditTopic) return null;

  return (
    <UIActionButton
      type={isPinned ? "unpin" : "pin"}
      onClick={updatePinState}
      isLoading={isLoading}
      hideLabel={hideButtonLabels}
    />
  );
};
